import React, { useState } from "react";
import { api, formatError } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "./ui/dialog";
import { toast } from "sonner";

const CHOICES = [
  ["period_end", "Keep access until it ends", (d) => `You keep everything until ${d}. No more reminders, nothing is charged.`],
  ["now", "Stop access now", () => "Your plan ends today. No refund for the remaining days."],
];

export default function CancelRenewalDialog({ token, expiry, onDone }) {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("period_end");
  const [busy, setBusy] = useState(false);
  const confirm = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/renewals/${token}/cancel`, { mode });
      toast.success(mode === "now" ? "Your plan has ended" : `Renewal cancelled — access until ${expiry}`);
      onDone(data); setOpen(false);
    } catch (e) { toast.error(formatError(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><Button data-testid="renew-cancel-btn" variant="outline" className="rounded-full h-11">Cancel renewal</Button></DialogTrigger>
      <DialogContent data-testid="cancel-renewal-dialog" className="bg-[#FFFDF9]">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-[#4A0E17]">Cancel renewal?</DialogTitle>
          <DialogDescription>Choose what happens to your plan.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {CHOICES.map(([key, title, desc]) => (
            <button key={key} type="button" data-testid={`cancel-mode-${key}`} onClick={() => setMode(key)}
              className={`w-full text-left rounded-xl border p-4 transition-colors ${mode === key ? "border-[#E65100] bg-[#F3E5AB]/40" : "border-[#D4AF37]/40 bg-white"}`}>
              <div className="font-semibold text-[#4A0E17]">{title}</div>
              <div className="text-sm text-[#63534E] mt-1">{desc(expiry)}</div>
            </button>
          ))}
        </div>
        <div className="flex justify-end gap-2 mt-2">
          <Button variant="ghost" onClick={() => setOpen(false)} data-testid="cancel-keep-btn">Keep my plan</Button>
          <Button data-testid="cancel-confirm-btn" disabled={busy} onClick={confirm} className="bg-[#4A0E17] text-[#F3E5AB] hover:bg-[#4A0E17]/90">{busy ? "Saving…" : "Confirm cancellation"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
